


































import { Vue, Component } from 'vue-property-decorator';
import T from '../../lang';
import omegaup_Markdown from '../Markdown.vue';

@Component({ components: { 'omegaup-markdown': omegaup_Markdown } })
export default class UserDeleteAccount extends Vue {
  T = T;
  showConfirmationModal = false;
  username = '';
}
